export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";